module.exports = __webpack_public_path__ + "static/media/edit-design-studio.f91f25c6.png";